import processModel from './processModel.vue';
import { upList } from './request';
export default {
  components: {
    processModel
  },
  data() {
    return {
      processShow: false,
      data: [],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: 'ID'
        },
        dataIndex: 'reviewNodeId',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '发布客户'
        },
        dataIndex: 'customerName',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '客户应用'
        },
        dataIndex: 'appName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '产品标识'
        },
        dataIndex: 'insuranceMark',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'customerInsuranceName',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '申请人'
        },
        dataIndex: 'userName',
        key: '7',
        align: 'center'
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: '8',
        align: 'center',
        width: 180
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        key: '9',
        align: 'center',
        width: 200
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      upList({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        status: 2
      }).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getTableFun();
    },
    handleSee(val) {
      this.processShow = true;
      this.$nextTick(() => {
        this.$refs.processFrom.init(val);
      });
    }
  }
};